import { Component, Input } from '@angular/core';
import { DtoWordDefinition } from '@common';
import { MarkdownPipe } from '../../../../shared';

@Component({
  selector: 'app-content-word-definition',
  imports: [MarkdownPipe],
  templateUrl: './content-word-definition.component.html',
  styleUrls: ['./content-word-definition.component.scss']
})
export class ContentWordDefinitionComponent {
  //#region Component Inputs --------------------------------------------------
  @Input() wordDefinition!: DtoWordDefinition;
  //#endregion
}
